"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUIZ_LOGIC_TYPE = void 0;
exports.QUIZ_LOGIC_TYPE = {
    MATCH: 'MATCH',
    TRIVIA: 'TRIVIA' // Only one of answers is correct. Count of questions = Count of results
};
//# sourceMappingURL=quizLogicType.js.map